import GLightbox from 'glightbox';

const lightbox = GLightbox({
    touchNavigation: true,
    loop: true
});

const switcher = document.querySelector('.gallery-expand');
if (switcher) {
    switcher.addEventListener('click', () => lightbox.open());
}
